<template>
  <div class="col-12 center-text">
    <div class="loading-block">
      <rotate-square4 :size="size"></rotate-square4>
    </div>
  </div>
</template>

<script>
import {RotateSquare4} from 'vue-loading-spinner';

export default {
  components: {
    RotateSquare4
  },
  props: {
    size: {
      default: '50px'
    }
  }
};
</script>

<style scoped>
.center-text, .center-text .loading-block {
  text-align: center;
  justify-content: center;
  align-content: center;
  display: flex;
}
</style>